import teamData from '../../json/team.json';
import "../../css/team1.css";

function TeamSection1() {
  const { team } = teamData;

  return (
    <section className="team1" id="team1">
      <div className="container">
        <div className="header">
          <h1>Conozca Nuestro Equipo</h1>
          <p>Profesionales talentosos dedicados a brindar soluciones de consultoría excepcionales y a impulsar el éxito de su negocio.</p>
        </div>

        <div className="team-grid">
          {team.map((member, index) => (
            <div className="team-card" key={index}>
              <div className="team-photo">
                {member.photo ? (
                  <img 
                    src={require(`../../${member.photo}`)} 
                    alt={member.name}
                    className="profile-picture"
                  />
                ) : (
                  <span className="initials">{member.initials}</span>
                )}
              </div>
              <div className="team-name">{member.name}</div>
              <div className="team-role">{member.role}</div>
              <div className="team-specialty">{member.specialty}</div>
              <div className="team-skills">
                {member.skills.map((skill, i) => (
                  <span key={i} className="skill-tag">{skill}</span>
                ))}
              </div>
              <div className="team-contact">
                <a href={`mailto:${member.contact.email}`} className="contact-link">📧</a>
                <a href={member.contact.linkedin} className="contact-link">💼</a>
                {/*<a href={`https://wa.me/${member.contact.phone}?text=Hola%20${member.name}`} className="contact-link" target="_blank" rel="noopener noreferrer">📞</-a>*/}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamSection1;